export const LANGUAGES = {
  en: 'English US',
  es: 'Español',
  pt: 'Português',
};
export const DEFAULT_LANGUAGE = 'en';
export const CHANGE_LANGUAGE_URL = window.__CONFIG__
  ? window.__CONFIG__.CHANGE_LANGUAGE_PATH
  : '/search/v1/api/change_lang/';
